// generated from 13_334 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const channelRankFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("channel_rank_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 5_328 (39.96%), defined 8_006 (60.04%)
  raw_value: z
    .enum([
      "Email", // 2_697 (33.69%)
      "Mobile push", // 2_321 (28.99%)
      "SMS", // 1_837 (22.95%)
      "Not enough data", // 711 (8.88%)
      "Web push", // 253 (3.16%)
      "WhatsApp", // 181 (2.26%)
      "unknown", // 6 (0.07%)
    ])
    .optional(),
  value: z.enum([
    "Email", // 5_037 (37.78%)
    "SMS", // 4_172 (31.29%)
    "Mobile push", // 2_680 (20.10%)
    "Not enough data", // 902 (6.76%)
    "Web push", // 340 (2.55%)
    "WhatsApp", // 197 (1.48%)
    "unknown", // 6 (0.04%)
  ]),
  varies_by_app_group: z.literal(false),
});
